export const contactExportState = {
	notStarted: 'notStarted',
	starting: 'starting',
	running: 'running',
	completing: 'completing',
	failed: 'failed',
	completed: 'completed'
} as const
